export default {
    menu_label: 'Outreach tasks',

    heading: 'Outreach tasks',

    filters: {
        from_date: 'From date',
        to_date: 'To date',
    },

    table: {
        task_id: 'Task ID',
        pool_id: 'Pool ID',
        provider: 'Provider',
        npi: 'NPI',
        channel: 'Channel',
        status: 'Status',
        scheduled_for: 'Scheduled for',
        sent_at: 'Sent at',
        created_at: 'Created at',
        no_tasks: 'No outreach tasks found',
    },

    status: {
        PENDING: 'Pending',
        PROCESSING: 'Processing',
        PROCESSED: 'Sent',
        CANCELLED: 'Cancelled',
    },

    channel: {
        fax: 'Fax',
        email: 'Email',
        sms: 'SMS',
    },

    pagination: {
        info: 'Page {current} of {total}',
    },

    notifications: {
        load_failed: 'Failed to load outreach tasks',
    },
}
